import type { SpUser } from "../interfaces/IEquipe"
import { BaseService } from "./BaseService"

export default class EquipeService extends BaseService {
  async get(): Promise<Array<SpUser>> {
    return this.executeQuery<Array<SpUser>>(
      "Equipe",
      {},
      "récupération équipe complète",
    )
  }

  async getSpUser(Id: string): Promise<SpUser> {
    const query = {
      $filter: this.createEqualFilter("Id", Id),
    }

    const results = await this.executeQuery<Array<SpUser>>(
      "Equipe",
      query,
      `récupération utilisateur ${Id}`,
    )

    if (!results || results.length === 0) {
      throw new Error(`Utilisateur avec l'ID ${Id} introuvable`)
    }

    return results[0]
  }

  async getSpUsers(Ids: Array<string>): Promise<Array<SpUser>> {
    if (Ids.length === 0) {
      return []
    }

    // Optimisation: requête unique avec filtre IN au lieu d'appels multiples
    const query = {
      $filter: this.createInFilter("Id", Ids),
    }

    const results = await this.executeQuery<Array<SpUser>>(
      "Equipe",
      query,
      `récupération utilisateurs multiples (${Ids.length} IDs)`,
    )

    // Vérifier que tous les IDs ont été trouvés
    const foundIds = results.map((user) => user.Id)
    const missingIds = Ids.filter((id) => !foundIds.includes(id))

    if (missingIds.length > 0) {
      console.warn(`Utilisateurs non trouvés:`, missingIds)
    }

    return results
  }
}
